<template>
  <div class="search">
    <form class="form" @submit.prevent="checkForm" action="/searches" accept-charset="UTF-8" novalidate="novalidate" method="post">
      <fieldset>
        <div class="contain">
          <div class="box wht">
            <p class="errorMsg">Enter a region</p>

            <label for="region">Town, county or region</label>
            <input @change="removeError" tabindex="1" id="region" class="valid text region" v-autofill="" autocomplete="off" name="search[region]" placeholder="Town, county or region" type="text" v-model="filter.region">
          </div>
          <div class="box wht" :class="{'error': errors.date }">
            <p class="errorMsg">Enter a date</p>
            <label for="date">Check in date</label>
            <input @change="removeError" tabindex="2" name="search[check_in_on]" v-picker="" class="valid text" v-model="filter.check_in_on" readonly type="text" autocomplete="off" id="date" placeholder="Check in" />
          </div>
          <div class="split">
            <div class="box wht" :class="{'error': errors.nights }">
              <p class="errorMsg">Enter nights</p>
              <label for="nights">Nights</label>
              <svg class="arr" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="18" width="18" viewBox="0 0 185.343 185.343"><path d="M51.707 185.343a10.692 10.692 0 0 1-7.593-3.149 10.724 10.724 0 0 1 0-15.175l74.352-74.347L44.114 18.32c-4.194-4.194-4.194-10.987 0-15.175 4.194-4.194 10.987-4.194 15.18 0l81.934 81.934c4.194 4.194 4.194 10.987 0 15.175l-81.934 81.939a10.678 10.678 0 0 1-7.587 3.15z"></path></svg>
              <div class="select lft">
                <select @change="removeError" class="valid" tabindex="3" name="search[minimum_nights]" v-model="filter.minimum_nights" id="nights" aria-label="nights">
                  <option value="" disabled selected>Nights</option>
                  <option v-for="n in 28" :key="'select_' + n" :value="n">{{ n + ' ' + 'Nights' }}</option>
                </select>
              </div>
            </div>
            <div class="box wht" :class="{'error': errors.sleeps }">
              <p class="errorMsg">Enter guests</p>
              <label for="guests">Guests</label>
              <svg class="arr" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" height="18" width="18" viewBox="0 0 185.343 185.343"><path d="M51.707 185.343a10.692 10.692 0 0 1-7.593-3.149 10.724 10.724 0 0 1 0-15.175l74.352-74.347L44.114 18.32c-4.194-4.194-4.194-10.987 0-15.175 4.194-4.194 10.987-4.194 15.18 0l81.934 81.934c4.194 4.194 4.194 10.987 0 15.175l-81.934 81.939a10.678 10.678 0 0 1-7.587 3.15z"></path></svg>
              <div class="select rgt">
                <select @change="removeError" tabindex="4" class="valid" name="search[sleeps]" v-model="filter.sleeps" id="guests" aria-label="guests">
                  <option value="" disabled selected>Guests</option>
                  <option v-for="n in 20" :key="'select_' + n" :value="n">{{ n + '+ ' + 'Guests' }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="box button">
            <button tabindex="5" type="submit" class="btn">
              <svg aria-labelledby="glass" xmlns="http://www.w3.org/2000/svg" height="19" width="19" viewBox="0 0 12.1 12.1">
                <title id="glass" lang="en">Magnifying glass icon</title>
                <path d="M9 7.8l3 3-1.3 1.3-3-3h.1c-.4.3-.9.5-1.3.7s-1 .2-1.5.2c-.7 0-1.4-.1-2-.4S1.9 9 1.5 8.5.7 7.6.4 7 0 5.7 0 5s.1-1.3.4-1.9S1 2 1.5 1.5 2.5.7 3.1.4 4.2 0 4.9 0s1.3.1 1.9.4S8 1 8.4 1.5s.8 1 1.1 1.6.4 1.2.4 1.9c0 .5-.1 1.1-.2 1.5s-.4.9-.7 1.3zm-2.8.1c.4-.2.7-.4 1-.7s.5-.6.7-1 .2-.7.2-1.2-.1-.8-.2-1.2-.4-.7-.7-1-.6-.5-1-.7-.8-.2-1.2-.2-.9.1-1.2.2-.8.4-1 .7-.5.6-.7 1-.3.8-.3 1.2.1.8.3 1.2.4.7.7 1 .6.5 1 .7.7.3 1.2.3.8-.1 1.2-.3z"></path>
              </svg>
              Search
            </button>
          </div>
          <input type="hidden" value="1" name="search[flex]" class="valid" />
        </div>
      </fieldset>
    </form>

    <div class="power">
      <h2>powered by</h2>
      <svg aria-labelledby="stlogo" viewBox="0 0 139.72 54.75" xmlns="http://www.w3.org/2000/svg">
        <title id="stlogo" lang="en">Snaptrip logo</title>
        <desc>Powered by Snaptrip logo</desc>
        <g>
          <path d="M78.74,20.75l-.11-.05a4.46,4.46,0,0,0-4.19.42,10.66,10.66,0,0,0-3.74,4.94c-.21.46-.41.94-.61,1.43,0-.19.27-.88.28-1.06,0,0,1.66-5.76.52-6.24A2.21,2.21,0,0,0,68,20.8a13.15,13.15,0,0,0-1.48,4.67c-.12,1.28-.34,2.73-.42,4.53a11.07,11.07,0,0,1-.6,1,9.77,9.77,0,0,1-1.18,1.42,4.57,4.57,0,0,1-1.35,1,1,1,0,0,1-.83.11c-.68-.31-2-1.89.45-9.84A9,9,0,0,0,62.87,22a1.71,1.71,0,0,0-1.12-1.74,1.62,1.62,0,0,0-1.32-.17h0a7.19,7.19,0,0,0-4.79.45A15,15,0,0,0,50.91,24a29.32,29.32,0,0,0-2.21,2.72,20.57,20.57,0,0,0-1.83,3.11A14,14,0,0,0,45.81,33a5.91,5.91,0,0,0-.14,1.59c-1.08.74-1.66.59-1.84-.35-.1-.55-.17-1-.28-1.66a20.66,20.66,0,0,1-.26-2.13q-.09-1.14-.15-2.25a41.7,41.7,0,0,0-.43-4.2,3.73,3.73,0,0,0-1.78-2.87,2.46,2.46,0,0,0-1.38-.37,3.61,3.61,0,0,0-1.88.59,11.76,11.76,0,0,0-3.44,3.31L34,25l.24-.92c.23-.86.27-.88.48-1.51a1.34,1.34,0,0,1,.38-.7,1.91,1.91,0,0,0,0-2.58,1.83,1.83,0,0,0-2.78-.18,4.09,4.09,0,0,0-.82,1.14,5.25,5.25,0,0,0-.7,1.71c-.12.41-.24.57-.38,1.09L30,24.74,29.2,28.1c-.32,1.39-.67,3-1,4.77-.18.63-.33,1.17-.42,1.63l-.19.94c-.51,2.27,0,2.92,1.13,3.21A2,2,0,0,0,31,37.41c.21-.4.67-1.06,1.25-2.12.39-.73.94-1.68,1.64-2.83s1.44-2.32,2.2-3.45,1.51-2.13,2.23-3,.77-.69.82,1.19c0,.46.08.87.09,1.27q.09,1.35.21,2.7c.16,1.67.29,6.9,2.77,8.11,1.69.83,4.89-1.27,4.89-1.27.86,1.21,4.2,1.13,7.8-1.34a21.53,21.53,0,0,0,3-2.53,4.9,4.9,0,0,0,2.74,2.94,4.42,4.42,0,0,0,3.73,0,9.58,9.58,0,0,0,1.42-.83l-.06.91-.59,15.67a1.34,1.34,0,0,0,.19,1l.11.15c.11.11.23.23.38.36a1.71,1.71,0,0,0,1.14.37A1.84,1.84,0,0,0,68.63,54a1.63,1.63,0,0,0,.3-.86l.84-7.52c.39-2.69.22-1.43.75-4.29a8,8,0,0,0,4.35-1.8,16.49,16.49,0,0,0,4.28-5.33,19,19,0,0,0,1.63-3.73,15.36,15.36,0,0,0,.69-3.76,8.29,8.29,0,0,0-.54-3.42A5,5,0,0,0,78.74,20.75ZM55.5,30.88c-1.81,2.24-3.38,3.58-4.77,4.07s-2.18-1.72,1.13-6a28.34,28.34,0,0,1,1.89-2.31,9.93,9.93,0,0,1,3.72-2.61c.08,0,1.39-.58,1.24.52A15.27,15.27,0,0,1,55.5,30.88Zm22.38-4a16.39,16.39,0,0,1-2.13,5.43,16.37,16.37,0,0,1-2.69,3.58,5.69,5.69,0,0,1-1.63,1.18c.29-1.24.59-2.43.91-3.58.43-1.57.89-3,1.35-4.23a16.5,16.5,0,0,1,1.5-3.09,5.26,5.26,0,0,1,1.49-1.66C77.66,23.83,78,25.82,77.88,26.86Z"></path>
          <path d="M99.22,20.86a5.81,5.81,0,0,0-4.08,1.76,14,14,0,0,0-1,1.13V23.6a6.45,6.45,0,0,0-.22-2,1.85,1.85,0,0,0-1-1.17,1.88,1.88,0,0,0-1.54,0,1.92,1.92,0,0,0-1,1A2,2,0,0,0,90.18,23a5.19,5.19,0,0,1,.11,1.76c0,1.11-.08,2.14-.19,3.56s-.22,2.66-.37,4-.28,2.48-.38,3.33a14.69,14.69,0,0,0-.16,1.54,2,2,0,0,0,1.89,2.41,1.67,1.67,0,0,0,1.44-.68,2.82,2.82,0,0,0,.44-.76,2.17,2.17,0,0,0,.12-.55,5,5,0,0,0,.21-1.22,5.72,5.72,0,0,1,.19-1.11c.26-1.11.6-2.32,1-3.58A24.84,24.84,0,0,1,96,28.2a11.24,11.24,0,0,1,1.74-2.55,2.07,2.07,0,0,1,1.51-.78,2,2,0,0,0,2-1.93,2.28,2.28,0,0,0-.45-1.43A1.69,1.69,0,0,0,99.22,20.86Z"></path>
          <path d="M106.48,29.39c.1-1.07.17-1.91.23-2.5a27.8,27.8,0,0,0,.28-2.82,1.89,1.89,0,0,0-.55-1.39,2,2,0,0,0-2.84-.07A2,2,0,0,0,103,24c0,.22,0,.54,0,1s-.08.92-.14,1.49c-.32,3.48-.5,6.23-.54,8.18,0,2.16.24,3.62,1,4.56a2.07,2.07,0,0,0,1.48.65,1.69,1.69,0,0,0,1.22-.4,1.8,1.8,0,0,0,.45-2.67,3.54,3.54,0,0,1-.15-1.29c0-.87,0-1.83.07-2.89S106.39,30.45,106.48,29.39Z"></path>
          <path d="M104.28,16.06a2.13,2.13,0,0,0-.7,1,1.68,1.68,0,0,0-.42,1.52,1.86,1.86,0,0,0,1.92,1.73h.23l.09,0a2.88,2.88,0,0,0,1-.37,2,2,0,0,0,.86-.91,1.93,1.93,0,0,0,.26-1,2.48,2.48,0,0,0-.5-1.44A1.84,1.84,0,0,0,104.28,16.06Z"></path>
          <path d="M124.47,23.88a5.12,5.12,0,0,0-2.31-2.61,4.46,4.46,0,0,0-4.19.42,10.73,10.73,0,0,0-3.74,4.94c-.21.47-.41.94-.6,1.44,0-.2,0-.38,0-.57a24.23,24.23,0,0,0,0-2.9,4.29,4.29,0,0,0-.37-2,1.75,1.75,0,0,0-.76-.7A1.78,1.78,0,0,0,111,21.8a2.05,2.05,0,0,0-1.1.84,1.92,1.92,0,0,0-.15,1.81c0,.26.08-.1,0,1.49,0,1.4-.13,3.12-.22,5.15l-.88,19.24,0,1a1.41,1.41,0,0,0,.2,1l.11.15c.11.11.23.23.37.35a1.76,1.76,0,0,0,1.15.37,1.85,1.85,0,0,0,1.74-.73,1.72,1.72,0,0,0,.3-.85l.09-1.14c.25-2.55.58-3.31,1-6.21.1-.69.14-1,.16-1.12a9.5,9.5,0,0,0,.26-1.29,8,8,0,0,0,4.35-1.8,16.67,16.67,0,0,0,4.29-5.34,18.88,18.88,0,0,0,1.62-3.72,14.62,14.62,0,0,0,.69-3.76,8.29,8.29,0,0,0-.53-3.42Zm-3,3.63a17.85,17.85,0,0,1-2.19,5.36h0a16.35,16.35,0,0,1-2.7,3.57A5.47,5.47,0,0,1,115,37.62c.29-1.25.59-2.44.9-3.58.43-1.55.89-3,1.36-4.22a16,16,0,0,1,1.5-3.1,5.09,5.09,0,0,1,1.49-1.65C121.13,24.45,121.8,25.74,121.48,27.51Z"></path>
          <path d="M133.91,4.32c-.24,1.17-.52,2.33-.75,3.51-.65,3.25-1.33,6.49-1.91,9.76-.52,2.91-1.52,8.84-1.95,11.62,0,.67-.05,1.2-.08,1.72a1,1,0,0,0,.49,1,1.72,1.72,0,0,0,2.66-1.11c.34-2.16,1.53-7.26,2.17-9.35,1.6-5.32,2.86-10.47,4.78-15.69C141.32.3,135.23-2,133.91,4.32Z"></path>
          <path d="M130.7,34a2.58,2.58,0,0,0-3.77.69,5.31,5.31,0,0,0-.73,2.46,3.94,3.94,0,0,0,2.15,3.5,2,2,0,0,0,1,.21,2.4,2.4,0,0,0,2-1.1,6.78,6.78,0,0,0,.64-1.33A4,4,0,0,0,130.7,34Z"></path>
          <path d="M108.89,8.76c-6.46.15-12.86.39-19.26.74l0-.16c.26-2,.45-3.42.56-4.36.16-1.35.19-.74.19-.92a1.88,1.88,0,0,0-.59-1.48,2,2,0,0,0-2.74,0A1.91,1.91,0,0,0,86.46,4c0,.09,0-.54-.22,1-.14,1.19-.3,2.56-.48,4.13l-.06.3,0,.33c-3.51.22-7,.46-10.54.75-2.59.22-3.86,4.34-.6,4.07,3.55-.3,7.09-.54,10.63-.76-.57,4.76-1.08,9.17-1.54,13.28-.5,4.49-.45,4.5-.78,7.81-.52,5.23,1.78,6,3.36,6A.84.84,0,0,0,87,39.73c-.5-1.24-.35-3.3,0-6.27.27-2.62.36-3.74.66-6.43s.59-5.31.89-7.86c.24-2.07.45-3.93.65-5.61,6.38-.35,12.75-.59,19.18-.74C110.91,12.76,112.15,8.69,108.89,8.76Z"></path>
          <path d="M18.15,18.29c-5.16-3.82-6-4.26-5.86-6.72.16-3.21,4.79-7.33,12.25-7.21,8.83.15,13,2.84,13,4.56,0,1.42-1.4,1.43-4.08,2-.66.15-2.14.72-2,2,.17,2.21,7.5,1.62,9.61-1C46.16,5.74,34.54,1.16,29.33.42c-9.52-1.35-14.88.74-18.42,4s-7.22,10.25,2,15.85c6.72,4.55,9.19,7,9,11.63-.28,6.39-8.16,7.46-10.42,7.54a7.54,7.54,0,0,1-5.93-2c-2.35-2.72-.11-7.16,5.79-7.38a1.55,1.55,0,0,0,1.59-1.36c0-.44-.26-1.55-3.15-2.15-2.08-.42-5.78,1.08-8,4-1.95,2.6-2.5,6.07-.87,8.64C5,45.53,16.62,44.74,21.32,41.5c.74-.52,4.72-3.23,5.41-8.09C27.86,25.42,22.64,21.62,18.15,18.29Z"></path>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import Pikaday from '../../../snaptrip-engine/app/assets/javascripts/lib/pikaday.js'
import autoComplete from '../../../snaptrip-engine/app/assets/javascripts/lib/autocomplete.js'

export default {
  data: function () {
    return {
       url: "searches/custom?",
       filter: {
        region: "",
        pets: "",
        check_in_on: "",
        minimum_nights: "",
        sleeps: ""
       },
       errors: {
         nights: false,
         date: false,
         region: false
       },
       label: "&utm_medium=partner&utm_source=travelsupermarket",
       prefix: "https://www.snaptrip.com/"
    }
  },
  props: {
    custom: Boolean
  },
  methods: {
    hasNumber (value) {
        let filter = /\d/;
        return filter.test(value);
    },
    notNull(field) {
        return field !== "" && typeof field !== "undefined";
    },
    constructUrl() {
        let app = this;
        let url = app.url,
            fields = app.$el.querySelectorAll(".valid");

        for (let i = 0; i < fields.length; i++) {
            let field = fields[i], string;
            if (app.notNull(field) && app.notNull(field.value)) {
                string = "&" + field.name + "=" + encodeURIComponent(field.value);
                url = url.concat(string);
            }
        }
        return app.prefix + url + app.label;
    },
    checkForm () {
      let scope = this;
      scope.clearAll();
      scope.validateForm();
    },
    clearAll() {
      this.errors.nights = false;
      this.errors.date = false;
      this.errors.region = false;
    },
    removeError(e) {
      this.errors[e.currentTarget.id] = false;
    },
    isRefOnly (value) {
      return this.hasNumber(value);
    },
    getUserDate: function(date, day) {
        let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            that = new Date(date),
            sp = " ",
            hasDay;
        hasDay = typeof day !== "undefined" ? days[that.getDay()] + sp : "";
        return hasDay + that.getDate() + sp + months[that.getMonth()] + sp + that.getFullYear();
    },
    getRequest () {
        return {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    },
    validateForm () {
      let app = this,
          form = this.$el.querySelector("form");

      if (app.filter.minimum_nights === 0 || app.filter.minimum_nights === "") {
          app.errors.nights = true;
      }
      if (app.filter.check_in_on === "") {
          app.errors.date = true;
      }
      if (!(app.errors.date || app.errors.nights)) {
          if (app.$props.custom) {
              window.open(app.constructUrl());
          } else {
              form.submit();
          }
      }
    },
    removeFocus() {
        let el = this.$el.querySelector(".outline");
        if (el) {
            el.classList.remove("outline");
        }
    },
    isFocus(e) {
        if (e.keyCode === 9) {
            this.removeFocus();
            document.activeElement.parentNode.classList.add("outline");
        }
    },
    passRegionFromUrl(url) {
      let app = this;
      let region = url.includes('region=') ? url.split('region=')[1] : "";
      app.filter.region = region.replace(/%20/gi, " ");
    },
    sortSuggestionLists(response, term) {
      let matchedArray = [];
      let unmatchedArray = [];
      let newArray = [];
      let inputValue = term.toUpperCase();

      response.forEach(value => {
          let locationName = value.split(",")[0].toUpperCase();

          if (locationName.indexOf(inputValue) === 0) {
              matchedArray.push(value);
          } else {
              unmatchedArray.push(value);
          }
      });

      newArray = [...matchedArray, ...unmatchedArray];
      return newArray
    }
  },
  directives: {
      'autofill': {
          inserted: (el, binding, vnode) => {
              let app = vnode.context;
              let url = app.prefix + "searches/autocomplete?query=";
              el.autofill = new autoComplete({
                  selector: el,
                  minChars: 1,
                  cache: false,
                  source: function (term, suggest) {
                      if (term.length > 2) {
                          fetch(url + encodeURIComponent(term.toLowerCase()) + app.label, app.getRequest())
                              .then((resp) => resp.json())
                              .then(function (data) {
                                  let newData = app.sortSuggestionLists(data, term);
                                  suggest(newData);
                              });
                          app.showSearchHistory = false;
                      } else {
                          app.showSearchHistory = true;
                      }
                  },
                  onSelect: function (e, term, item) {
                      e.preventDefault();
                      app.filter.region = term;
                      app.showSearch = false;
                  }
              });
          },
          unbind: (el) => {
              el.autofill.destroy();
          }
      },
      'picker': {
          inserted: (el, binding, vnode) => {
              let app = vnode.context;
              el.pikadayInstance = new Pikaday({
                  theme: "pika--res",
                  field: el,
                  bound: true,
                  keyboardInput: true,
                  format: 'D MM YYYY',
                  firstDay: 0,
                  reposition: false,
                  minDate: new Date(),
                  onSelect: function onSelect(date) {
                      app.filter.check_in_on = app.getUserDate(new Date(date));
                  }
              });
          },
          unbind: (el) => {
              el.pikadayInstance.destroy();
          }
      }
  },
  mounted() {
      const app = this,
            win = window;
      let ua = win.navigator.userAgent;

      win.addEventListener("keyup", app.isFocus);
      document.body.addEventListener("click", app.removeFocus);
      //src of the iframe may have region data as qyery string e.g ?region=cornwall
      app.passRegionFromUrl(location.href)
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.search {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  background: #322c44;
}

.power {
  padding: 0 0 .625rem 0;
  position: relative;
  left: .625rem;

  h2 {
    font-size: .625rem;
    margin-bottom: .125rem;
    color: $col_white;
    font-weight: 400;
    letter-spacing: -0.25;
  }

  svg {
    fill: $col_white;
    width: 3.25rem;
  }

  .isIE & svg {
    height: 2rem;
  }
}

.form {
  width: 100%;
  margin: 0;

  fieldset {
    border: none;
    margin: 0;
    padding: .625rem;
    box-sizing: border-box;
  }

  .contain {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  label, .errorMsg {
    font-size: .75rem;
    padding: .313rem 0 .313rem .625rem;
    display: block;
    margin: 0;
    position: absolute;
    top: 0;
    z-index: 5;
    pointer-events: none;
  }

  label {
    color: #322c44;
    width: 100%;
  }

  .error {
    outline: .125rem solid #cc2301;
    position: relative;
    z-index: 1;
  }

  .error label {
    display: none;
  }

  .errorMsg {
    display: none;
    box-sizing: border-box;
    padding-left: .625rem;
    padding-right: .625rem;
    color: #cc2301;
    width: 100%;
  }

  .error .errorMsg {
    display: block;
  }

  .split {
    display: flex;

    .box {
      width: calc(50% - .0625rem);

      &:first-of-type {
        margin-right: .125rem;
      }
    }
  }

  .btn {
    outline: 0;
    border: none;
    width: 100%;
    background: #e60;
    color: #FFF;
    font-size: 1.5rem;
    height: 3.125rem;
    text-decoration: none;
    transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out, color 0.2s ease-in-out;
    cursor: pointer;
    border-radius: .313rem;
    box-sizing: border-box;
    justify-content: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: 400;

    svg {
      fill: $col_white;
      width: .938rem;
      height: .938rem;
      position: relative;
      margin-right: .313rem;
    }

    &:hover {
      background: darken(#e60, 10%);
    }

    &:disabled {
      background: #CCC;
    }
  }

  .select select, .text {

    &, &::placeholder {
      font-weight: 700;
      color: #322c44;
      font-size: 1.125rem;
    }
  }

  .outline {
    .text, .btn, &.select {
      outline: .313rem solid #0096ff;
      position: relative;
      z-index: 2;
    }
  }

  .text {
    display: inline-block;
    min-width: 8rem;
    font-size: 1.125rem;
    box-sizing: border-box;
    box-shadow: none;
    padding: 1.25rem 1.875rem .313rem .625rem;
    height: 100%;
    outline: 0;
    -webkit-appearance: none;
    border: none;
    width: 100%;
    border-radius: .313rem;

    &:placeholder {
      font-weight: 700;
      color: #322c44;
    }
  }

  .region {
    min-width: 15rem;
  }

  .arr {
    fill: #e60;
    position: absolute;
    right: .625rem;
    bottom: .625rem;
    transform: rotate(90deg);
    z-index: 2;
    pointer-events: none;
  }

  .select {
    min-width: 8rem;
    overflow: hidden;
    position: relative;
    background-color: #fff;
    box-sizing: border-box;
    height: 100%;

    &.rgt {
      border-radius: 0 .313rem .313rem 0;
    }

    &.lft {
      border-radius: .313rem 0 0 .313rem;
    }

    select {
      font-size: 1.125rem;
      height: 100%;
      padding: 1.25rem 1.875rem .313rem .625rem;
      box-sizing: border-box;
      width: 130%;
      border: none;
      box-shadow: none;
      background-color: transparent;
      background-image: none;
      -webkit-appearance: none;
      appearance: none;
      outline: 0;

      .isIE & {
        width: 140%;
      }
    }
  }

  .isIE .select select {
    width: 140%;
  }

  .box {
    border-radius: .313rem;
    position: relative;

    &.wht {
      background-color: $col_white;
      margin-bottom: .625rem;
      height: 3.125rem;
    }

    &.button {
      height: 3.125rem;
    }

    &.error .arr {
      fill: #E84118;
    }

    &.error .text,
    &.error .select select {
      color: #E84118;

      &::placeholder {
        color: #E84118;
      }
    }

    &.error .select:after {
      color: #E84118;
    }
  }
}

@media only screen and (min-width: 64rem) {
  .search {
    max-width: 64rem;
    height: 7.5rem;
    box-sizing: border-box;
  }

  .box {
    width: calc(100% - .0625rem);
    margin-right: .125rem;
  }

  .power {
    position: absolute;
    bottom: .125rem;
    left: inherit;
    right: 1.25rem;

    h2 {
      text-align: right;
    }

    .isIE & {
      bottom: 1.5rem;

      svg {
        position: absolute;
        right: 0;
        top: .75rem;
      }
    }
  }

  .form {
    .contain {
      flex-direction: row;
      align-items: stretch;
    }

    .btn, .box, .text, .select, .select.rgt, .select.lft {
      border-radius: 0;
    }

    fieldset {
      padding-right: .625rem;
    }

    .split {

      .box {
        margin: 0;
        padding: 0;
        width: calc(50% - .313rem);

        &:first-of-type {
          margin-right: .125rem;
        }
      }
    }

    .box {
      flex-grow: 1;

      &.button {
        height: inherit;
        max-width: 7.5rem;
      }
    }

    .btn {
      font-size: 1.063rem;
      font-weight: 500;
    }

    .isIE & .box {
      width: 11.5rem;
    }
  }
}

</style>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';
@import url('https://fonts.googleapis.com/css2?family=Barlow:wght@400;700&display=swap');

html, body, div, span, h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins,
kbd, q, s, samp, small, strong, tt, var, dl, dt,
dd, ol, ul, li, fieldset, form, input, select, button, textarea, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, figcaption, figure,
footer, header, hgroup, main, menu, nav, section {
  margin: 0;
  padding: 0;
  border: 0;
  font-family: Barlow, BlinkMacSystemFont, system-ui, Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.search *,
.pika-single *,
.autocomplete-suggestions * {
  margin: 0;
  padding: 0;
  font-family: Barlow, BlinkMacSystemFont, system-ui, Roboto, Helvetica, Arial, sans-serif;
}

.search *,
.autocomplete-suggestions * {
  -webkit-font-smoothing: antialiased;
}

.pika {

  &-single {
    z-index: 99;
    border-radius: .313rem;
    display: block;
    position: relative;
    color: #333;
    background: $col_white;
    width: 100%;
    max-width: 17.813rem;
    max-height: 25rem;
    opacity: 1;
    margin-top: .5rem;
    padding: .313rem;
    box-shadow: .0625rem 0 0 #e6e6e6, -.0625rem 0 0 #e6e6e6, 0 .0625rem 0 #e6e6e6, 0 -.0625rem 0 #e6e6e6, 0 .188rem .813rem rgba(0,0,0,.08);

    &:before {
      content: "";
      position: absolute;
      display: block;
      pointer-events: none;
      border: solid transparent;
      height: 0;
      width: 0;
      left: 1.375rem;
      bottom: 100%;
      border-width: .313rem;
      margin: 0 -.313rem;
      border-bottom-color: #e6e6e6;
    }

    &.is-hidden {
      display: none;
    }
  }

  &--sdw {
    box-shadow: 0 0.125rem 0.125rem $col_quartopacity;
  }

  &-single {

    &:before,
    &:after {
      content: "";
      display: table;
    }

    &:after {
      clear: both
    }
  }

  &-lendar {
    background-color: $col_white;
    box-sizing: border-box;
  }

  &-title {
    position: relative;
    margin-bottom: .25rem;
    text-align: center;
    background-color: $col_white;
    color: $col_grey;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    select {
      cursor: pointer;
      position: absolute;
      z-index: 9998;
      margin: 0;
      left: 0;
      filter: alpha(opacity=0);
      opacity: 0;
    }
  }

  &-label {
    display: inline-block;
    position: relative;
    z-index: 9999;
    overflow: hidden;
    margin: 0;
    font-weight: 400;
    font-size: 1.25rem;
    color: rgba(0,0,0,.9);
    appearance: none;
    -webkit-appearance: none;
    padding: .75rem .25rem .5rem 0;
  }

  &-prev,
  &-next {
    display: block;
    cursor: pointer;
    outline: none;
    border: 0;
    color: #000;
    width: 12.5%;
    height: 100%;
    text-indent: -999rem;
    white-space: nowrap;
    overflow: hidden;
    background-color: transparent;
    background-position: center center;
    background-repeat: no-repeat;
    opacity: 1;
    position: absolute;
    top: 0;
    background-size: 1rem;

    &.is-disabled {
      cursor: default;
      opacity: 0;
      background-color: transparent;
    }
  }

  &-prev {
    left: 0;
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTAgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICAgICAgICA8dGl0bGU+QXJyb3c8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGRlZnM+PC9kZWZzPiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgICAgIDxnIGlkPSJEZXNrdG9wIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjAuMDAwMDAwLCAtMTUyLjAwMDAwMCkiPiAgICAgICAgICAgIDxnIGlkPSJIb21lcGFnZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzAuMDAwMDAwLCA3OC4wMDAwMDApIj4gICAgICAgICAgICAgICAgPGcgaWQ9IkNoZWNrLUluIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgNDkuMDAwMDAwKSI+ICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iRGF0ZS1waWNrZXIiPiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJNb250aCI+ICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJBcnJvdyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzYuMDAwMDAwLCAzMy4wMDAwMDApIHNjYWxlKC0xLCAxKSB0cmFuc2xhdGUoLTM2LjAwMDAwMCwgLTMzLjAwMDAwMCkgdHJhbnNsYXRlKDI0LjAwMDAwMCwgMjEuMDAwMDAwKSI+ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTkiIHg9IjAiIHk9IjAiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PC9yZWN0PiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJQYXRoLTMtQ29weS0yIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiIgcG9pbnRzPSI5IDUgMTYgMTIgOSAxOSI+PC9wb2x5bGluZT4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgIDwvZz4gICAgICAgIDwvZz4gICAgPC9nPjwvc3ZnPg==);
  }

  &-next {
    right: 0;
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTAgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICAgICAgICA8dGl0bGU+UGF0aCAzIENvcHkgMjwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9IkRlc2t0b3AiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNjguMDAwMDAwLCAtMTUyLjAwMDAwMCkiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSIjMDAwMDAwIj4gICAgICAgICAgICA8ZyBpZD0iSG9tZXBhZ2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMwLjAwMDAwMCwgNzguMDAwMDAwKSI+ICAgICAgICAgICAgICAgIDxnIGlkPSJDaGVjay1JbiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDQ5LjAwMDAwMCkiPiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9IkRhdGUtcGlja2VyIj4gICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iTW9udGgiPiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iQXJyb3ciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMzMC4wMDAwMDAsIDIxLjAwMDAwMCkiPiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJQYXRoLTMtQ29weS0yIiBwb2ludHM9IjkgNSAxNiAxMiA5IDE5Ij48L3BvbHlsaW5lPiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2c+ICAgICAgICAgICAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgICAgICA8L2c+ICAgICAgICAgICAgPC9nPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+);
  }

  &-select {
    display: inline-block;
  }

  &-table {
    width: 100%;
    border: 0;
    box-sizing: border-box;

    th,
    td {
      width: 14.285714285714286%;
      height: 2.5rem;
      box-sizing: border-box;
    }

    th,
    th abbr {
      text-align: center;
      padding-bottom: .25em;
      color: #999;
      font-size: .7rem;
    }

    th abbr {
      text-decoration: none;
      font-size: .75rem;
      color: rgba(0,0,0,.54);
      font-weight: 700;
    }
  }

  &-button {
    cursor: pointer;
    position: relative;
    display: block;
    box-sizing: border-box;
    outline: none;
    border: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    font-size: .875rem;
    text-align: center;
    background-color: $col_white;
    border-radius: 9.375rem;

    &:hover {
      background: #e6e6e6;
      border-color: #e6e6e6;
    }

    .is-selected & {
      color: $col_white;
      background-color: #e60;
    }

    .is-highlight & {
      position: relative;

      &:before {
        content: "";
        height: 2.375rem;
        width: 2.375rem;
        border: 0.125rem solid $col_orange;
        border-radius: 100%;
        position: absolute;
        box-sizing: border-box;
        top: .2rem;
        left: .25rem;
      }
    }

    .is-selected.is-highlight &:before {
      border: 0;
    }

    .is-highlight.is-disabled & {
      background: none;
    }

    .is-disabled &,
    .is-outside-current-month & {
      pointer-events: none;
      cursor: default;
      border-radius: 0;
      color: rgba(57,57,57,.2);
    }
  }

  &-week {
    font-size: 0.688rem;
    color: #999;
  }

  .is-inrange &-button {
    background: lighten($col_orange, 10%);
    color: $col_white;
  }

  .is-startrange &-button {
    color: $col_white;
    background: #6CB31D;
    box-shadow: none;
  }

  .is-endrange &-button {
    color: $col_white;
    background: #33aaff;
    box-shadow: none;
  }
}

.autocomplete-suggestions {
  text-align: left;
  cursor: default;
  border-top: 0;
  background: #fff;
  position: absolute;
  z-index: 9999;
  max-height: 15.875rem;
  overflow: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  box-shadow: .0625rem 0 0 #e6e6e6, -.0625rem 0 0 #e6e6e6, 0 .0625rem 0 #e6e6e6, 0 -.0625rem 0 #e6e6e6, 0 .188rem .813rem rgba(0, 0, 0, .08);
}

.autocomplete-suggestion {
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #fff;
  border: 0;
  color: #322c44;
  font-size: 1.063rem;
  padding: .5rem;
  text-align: left;
  width: 100%;

  &:hover, &.selected {
    background-color: lighten(#e60, 40%);
  }
}

</style>